// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headerPage[data-v-b07fcf76]{background-color:#67d2df;height:73px}.titleHeader[data-v-b07fcf76]{-webkit-box-flex:0!important;-ms-flex:none!important;flex:none!important;margin-right:85px}", ""]);
// Exports
module.exports = exports;
